import i18n from 'i18next';
import i18nBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import {
  DEFAULT_LANGUAGE,
  getStoredLanguage,
  SUPPORTED_LANGUAGES,
} from './languages';

const language = getStoredLanguage();
document.documentElement.lang = language;

i18n
  .use(i18nBackend)
  .use(initReactI18next)
  .init({
    react: {
      useSuspense: false,
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    fallbackLng: DEFAULT_LANGUAGE,
    interpolation: {
      escapeValue: false,
    },
    lng: language,
    whitelist: SUPPORTED_LANGUAGES,
  });

export default i18n;
